import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.267 2.299a.75.75 0 0 0-.828.203l-8 9a.75.75 0 0 0 0 .996l8 9A.75.75 0 0 0 11.75 21v-5.194q.202.023.448.06c.768.118 1.836.356 3.024.83 1.083.434 2.36 1.571 3.42 2.694a28 28 0 0 1 1.728 2.02l.023.031.006.007v.002A.75.75 0 0 0 21.75 21H21h.75v-.07l-.005-.177a16 16 0 0 0-.036-.645 21 21 0 0 0-.284-2.182c-.322-1.738-.974-3.985-2.315-5.862-1.361-1.906-3.375-3.1-4.995-3.813a17 17 0 0 0-2.365-.84V3a.75.75 0 0 0-.483-.701m-.414 6.437.008.001.035.008.148.034c.13.032.324.081.566.152a16 16 0 0 1 1.9.693c1.505.662 3.241 1.718 4.38 3.312 1.16 1.623 1.757 3.626 2.06 5.263q.045.25.083.484l-.3-.323c-1.065-1.127-2.538-2.49-3.955-3.056a15.4 15.4 0 0 0-3.351-.92 12 12 0 0 0-1.312-.132l-.08-.002h-.034L11 15v-.75a.75.75 0 0 0-.75.75v4.027L4.003 12l6.247-7.027V8a.75.75 0 0 0 .603.736",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }